import { runInAction, reaction, makeAutoObservable } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { history } from "../..";
import { ITenant } from "../models/tenant";
import cmsThemes from "../models/theme";
import { IAttendingUser } from "../models/user";
import * as signalR from "@microsoft/signalr";
import { toast } from "react-toastify";
import shareSyncType from "../models/shareSyncStatus";
import {
  IHubResponse,
  IMeetingAttendanceStatus,
  IMeetingAttendees,
  IGalleryFile,
  ISharedObject,
} from "../models/dto";
import hubResponseCode from "../models/hubResponse";
import UserIsSharingToast from "../../components/toast/UserIsSharingToast";
import { updateTenantsList } from "../sqlite/utilities";
import { getExistingAssetUrl } from "../models/content";
import { VideoWidgetCommandTypes } from "../models/widget";
import screenStatusType from "../models/screens";
import { getToastTranslation } from "../helpers/translationHelper";
import { changePrincipalLanguage } from "../localization/localization";

export default class TenantStore {
  rootStore: RootStore;
  refreshTokenTimeout: any;
  sharingInterval: any;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);

    reaction(
      () => this.currentTenant,
      (currentTenant) => {
        if (currentTenant) {
          this.startSignalR();
          document.title = currentTenant.name;
          const favicon = document.getElementById("favicon") as HTMLLinkElement;
          if (favicon)
            favicon.href = getExistingAssetUrl("tenants", currentTenant.path, "favicon.ico");
          // let theme = cmsThemes.get(currentTenant.theme);
          // this.rootStore.commonStore.theme = theme
          //   ? theme
          //   : cmsThemes.get("default");
          this.rootStore.commonStore.theme = cmsThemes.get("template")
          this.rootStore.commonStore.loadThemeTenant(currentTenant.theme);

          // console.log("THEME:" + currentTenant.theme);

          if (this.rootStore.commonStore.isNativeApp) {
            console.log("Entrato!")
            const { loadAlreadyDownloadedData } = this.rootStore.offlineStore;
            loadAlreadyDownloadedData(currentTenant.id);
          }
        } else {
          this.rootStore.commonStore.theme = cmsThemes.get("default");
        }
      }
    );

  }

  connection: signalR.HubConnection | null = null;
  loadingInitial = false;
  tenantArray: ITenant[] | null = null;
  currentTenant: ITenant | null = null;
  disconnectedModalOpen: boolean = false;
  alreadyCheckedMeetingAttendance: boolean = false;
  sharingWidgetInProgress: boolean = false;
  canViewODG : boolean= false;
  canViewArchive : boolean= false;

  get errorUrl() {
    return  this.currentTenant ? `${this.currentTenant.path}/notfound` : "/";;
  }

  loadTenants = async () => {
    this.loadingInitial = true;
    try {
      const tenants = await agent.Tenant.list();

      if(this.rootStore.commonStore.isNativeApp && tenants && tenants.length > 0)
      await updateTenantsList(tenants);

      runInAction(() => {
        this.tenantArray = tenants;
        this.loadingInitial = false;
      });

    } catch (error) {
      runInAction(() => {
        this.loadingInitial = false;
      });
    }
  };

  signInByPath = async (path: string) => {
    try {
      console.log("sign")
      let names = this.tenantArray
        ? this.tenantArray.reduce((a: string[], o) => (a.push(o.path), a), [])
        : [];
      let index = names.indexOf("/" + path);
      if (index >= 0) {
        let tenant = this.tenantArray![index];
        const dto = await agent.Player.signin(tenant.id);
       runInAction(() => {
          const {playerStore, userStore} = this.rootStore;
          playerStore.setUserMeetings(dto.meetings);
          userStore.user = dto.user;
          this.canViewODG= dto.canViewODG;
          this.canViewArchive= dto.canViewArchive;
          this.currentTenant = tenant;
          changePrincipalLanguage(dto.user.languageId);
          userStore.activateLogoutTimer(); //per la modale di avviso logout
        });
        return dto;
      } else {
        history.push("/home");
      }
    } catch (error) {
      throw error;
    }
  };

  

  // refreshToken = async () => {
  //   try {
  //       const dto = await agent.Player.refreshToken();
  //       runInAction(() => {
  //         const {playerStore, userStore} = this.rootStore;
  //         playerStore.setUserMeetings(dto.meetings);
  //         userStore.user = dto.user;
  //         this.canViewODG= dto.canViewODG;
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // public startRefreshTokenTimer(user: IUser) {
  //   try {
  //     const jwtToken = JSON.parse(atob(user.token.split(".")[1]));
  //     const expires = new Date(jwtToken.exp * 1000);
  //     const timeout = expires.getTime() - Date.now() - 60 * 1000;
  //     this.refreshTokenTimeout = setTimeout(this.refreshToken, timeout);
  //   } catch (error) {
  //     console.log("startRefreshTokenTimer - " + error);
  //   }
  // }

  // public stopRefreshTokenTimer() {
  //   try {
  //     clearTimeout(this.refreshTokenTimeout);
  //   } catch (error) {
  //     console.log("stopRefreshTokenTimer - " + error);
  //   }
  // }

  public startSharingInterval() {
    try {
      if (this.rootStore.playerStore.isSharing) {
        const milliseconds = 500;
        this.sharingInterval = setInterval(this.sendSharedSlide, milliseconds);
      }
    } catch (error) {
      console.log("startSharingInterval - " + error);
    }
  }

  public stopSharingInterval() {
    try {
      clearInterval(this.sharingInterval);
    } catch (error) {
      console.log("stopSharingInterval - " + error);
    }
  }

  // SIGNLAR METHODS //
  startSignalR = async () => {
    let token = await agent.Player.startSignalR();
    // let token = this.rootStore.commonStore.token
    //   ? this.rootStore.commonStore.token
    //   : "";
    const header = process.env.REACT_APP_HEADER;
    
    if(header && token){
    const headers: signalR.MessageHeaders = {
      "tt-app": header,
    };
    const options : signalR.IHttpConnectionOptions = {
      headers: headers,
      accessTokenFactory: () => token
    }
    const maxReconnectTime = 30; // tempo in minuti!!
    const startTime = Date.now();
    this.disconnectedModalOpen = false;
    const signalRUrl = process.env.REACT_APP_DOMAIN! + process.env.REACT_APP_SIGNALR_URL!;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(signalRUrl, options)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          const elapsedTime = Date.now() - startTime;
          if (elapsedTime > (maxReconnectTime * 60000)) {
            return null; // Ferma i tentativi dopo il tempo massimo
          }
          return Math.min(5000 * retryContext.previousRetryCount, 15000); 
          // Aumenta il tempo fino a un massimo di 15s
        }
      })
      .build();

      // metodi di connessione
      this.connection.onclose((error) => {
        runInAction(() => (this.disconnectedModalOpen = true));
        if (error) {
          console.log("onclose: " + error);
        }
      });

      this.connection.onreconnecting((error) => {
        this.disconnectedModalOpen = true;
        if (error) {
          console.log("onreconnecting: " + error);
        }
      });

      this.connection.onreconnected(() => {
        console.log("reconnected");
        this.disconnectedModalOpen = false;
        this.alreadyAttendingCheck();
      });

      // metodi ricezione messaggi
      this.connection.on("UserDisconnected", (userId: number) =>
        this.rootStore.playerStore.removeUserFromMeeting(userId)
      );
      this.connection.on("UserJoinedMeeting", (user: IAttendingUser) => {
        const { playerStore, zwibblerStore } = this.rootStore;
        playerStore.addUserToMeeting(user);
        if (playerStore.isSharing) {
          zwibblerStore.updateSharedZwibblerDrawing();
        }
      });
      this.connection.on("UserIsSharing", (user: IAttendingUser) => {
        const { playerStore, commonStore } = this.rootStore;
        const { autoOnairOnSharing, setOnair } = this.rootStore.screensStore
        //interrompere la propria condivisione
        if (playerStore.isSharing) {
          playerStore.setShareSyncStatus(shareSyncType.Sync);
          if (autoOnairOnSharing) setOnair(false);
          this.stopSharingInterval();
          toast.info(getToastTranslation("sharing_stopped"));
        }
        //autosync
        if (commonStore.isAutoSyncEnabled && !playerStore.isSynced)this.enableSync();

        const displayName =
          user.lastName && user.firstName
            ? `${user.firstName} ${user.lastName}`
            : user.userName;
        playerStore.setCurrentSharingUser(user.id);
        toast.info(
          (props) =>
            UserIsSharingToast({
              username: displayName,
              toastContentProps: props
            }),
          { toastId: `UserIsSharingToast_${displayName}` }
        );
      });
      this.connection.on("SharingEnded", () => {
        this.rootStore.playerStore.setCurrentSharingUser();
        this.rootStore.playerStore.setSynchronizationObject(null);
        const { isSharing, isSynced } = this.rootStore.playerStore;
        if (isSharing || isSynced) {
          this.disableShareSync();
        }
      });
      this.connection.on("SharedObject", (sharedObj: ISharedObject) => {
        if (sharedObj) {
          this.rootStore.playerStore.setSynchronizationObject(sharedObj);
        }
      });
      this.connection.on("SharedZwibblerDrawing", (sharedDrawing: string) => {
        this.rootStore.zwibblerStore.setSharedZwibblerDrawingData(sharedDrawing);
        this.rootStore.zwibblerStore.loadSharedZwibblerDrawing();
      });
      this.connection.on("ShowSurvey", (meetingId: number, surveyId: number) => this.rootStore.surveyStore.OnShowSurveyEvent(meetingId, surveyId));
      this.connection.on("ShowSurveyResults", (meetingId: number, surveyId: number) => this.rootStore.surveyStore.OnShowSurveyResultsEvent(meetingId, surveyId));
      this.connection.on("UpdateSurveyResults", (meetingId: number, surveyId: number) => this.rootStore.surveyStore.OnUpdateSurveyResultsEvent(meetingId, surveyId));
      this.connection.on("EventOnSurvey", (meetingId: number, surveyId: number, eventType: "Open" | "Close" | "Archivie" | "Clear" | "Delete") => this.rootStore.surveyStore.OnReceivedEventOnSurvey(meetingId, surveyId, eventType));
      this.connection.on("PingMsg", (text: string) => toast.info(text));
      this.connection.on("CustomWatermarkReady", (contentId: number) =>
        this.rootStore.commonStore.handleCustomWatermarkNotification(contentId)
      );

      this.connection
        .start()
        .then(() => {
          console.log("connection started");
          this.alreadyAttendingCheck();
        })
        .catch(() => console.log("connection KO"));
    } else {
      console.log("token not found");
    }
  };

  alreadyAttendingCheck = async () => {
    try {
      await this.connection!.invoke("AttendanceRequest")
        .then(async (res: IMeetingAttendanceStatus) => {
          {
            if (res && res.meetingId) {
              let { meetingId, shareSyncStatus } = res;
              if (meetingId > 0) await this.attendMeeting(meetingId);
              if (shareSyncStatus === shareSyncType.Share) this.enableShare();
              else if (shareSyncStatus === shareSyncType.Sync)
                this.enableSync();
            } else {
              this.rootStore.playerStore.resetAttendingMeeting();
            }
            runInAction(() => this.alreadyCheckedMeetingAttendance = true);
          }
        })
        .catch(() => {
          this.disconnectedModalOpen = true;
          window.location.reload();
        });
    } catch (error) {
      console.log("alreadyAttendingCheck - " + error);
    }
  };

  attendMeeting = async (meetingId: number) => {
    let result = false;
    try {
      const { attendingMeeting } = this.rootStore.playerStore;
      if (attendingMeeting && attendingMeeting.id !== meetingId)
        await this.leaveMeeting(attendingMeeting.id, false);

      await this.connection!.invoke("AttendMeeting", meetingId).then(
        (res: IHubResponse) => {
          if (res && res.code === hubResponseCode.Ok) {
            result = true;
            this.rootStore.playerStore.setAttendingMeeting(meetingId);
            this.getMeetingAttendees(meetingId);
          }
        }
      );
    } catch (error) {
      console.log("attendMeeting - " + error);
    }
    console.log(this.rootStore.playerStore.attendingMeeting)

    return result;
  };

  getMeetingAttendees = async (meetingId: number) => {
    try {
      await this.connection!.invoke("GetMeetingAttendees", meetingId).then(
        (res: IMeetingAttendees) => {
          if (res) {
            this.rootStore.playerStore.setAttendingMeetingUsers(res.attendees);
            if (res.sharingUserId)
              this.rootStore.playerStore.setCurrentSharingUser(
                res.sharingUserId
              );
          }
        }
      );
    } catch (error) {
      console.log("attendMeeting - " + error);
    }
  };

  leaveMeeting = async (meetingId: number, redirectToMeetings: boolean = true) => {
    try {
      const { isSharing, isSynced } = this.rootStore.playerStore;
       if (isSharing || isSynced) await this.disableShareSync();

      const{resetSurveyParameters}= this.rootStore.surveyStore
     resetSurveyParameters();
     const{updateDocumentalView} = this.rootStore.meetingStore
     updateDocumentalView(true);
     
      await this.connection!.invoke("LeaveMeeting", meetingId)
        .finally(() => {
          this.rootStore.playerStore.resetAttendingMeeting();
          const redirectUrl = this.currentTenant
            ? `${this.currentTenant.path}/meetings`
            : `/`;

          if (redirectToMeetings) history.push(redirectUrl);
        });
    } catch (error) {
      console.log("leaveMeeting - " + error);
    }
  };

  enableShare = async () => {
    try {
      if (this.rootStore.playerStore.attendingMeeting) {
        this.connection!.invoke(
          "EnableShareMode",
          this.rootStore.playerStore.attendingMeeting.id
        ).then(() => {
          this.rootStore.playerStore.setShareSyncStatus(shareSyncType.Share);
          this.rootStore.playerStore.setCurrentSharingUser(
            this.rootStore.userStore.user!.id
          );

          this.rootStore.playerStore.setSharedObject();
          this.rootStore.zwibblerStore.updateSharedZwibblerDrawing();
          this.startSharingInterval();

          const { autoOnairOnSharing, setOnair } = this.rootStore.screensStore
          if (autoOnairOnSharing) setOnair(true);
        });
      }
    } catch (error) {
      console.log("enableShare - " + error);
    }
  };

  enableSync = async () => {
    try {
    //  toast.error("enableSync");
     this.rootStore.commonStore.setIsGallery(false);
      if (this.rootStore.playerStore.attendingMeeting) {
        this.connection!.invoke(
          "EnableSyncMode",
          this.rootStore.playerStore.attendingMeeting.id
        ).then(() => {
          this.rootStore.playerStore.setShareSyncStatus(shareSyncType.Sync);
          localStorage.setItem('lastActivity', new Date().toISOString())
        });
      }
    } catch (error) {
      console.log("enableSync - " + error);
    }
  };

  disableShareSync = async () => {
    try {
      // toast.error("disableShareSync");
      this.rootStore.commonStore.setIsGallery(true);
      if (this.rootStore.playerStore.attendingMeeting) {
        const methodToCall = this.rootStore.playerStore.isSharing
          ? "DisableShareMode"
          : "DisableSyncMode";
        this.connection!.send(
          methodToCall,
          this.rootStore.playerStore.attendingMeeting.id
        ).then(() => {
          this.rootStore.playerStore.setShareSyncStatus(shareSyncType.Disabled);
          this.stopSharingInterval();

          const { autoOnairOnSharing, setOnair } = this.rootStore.screensStore
          if (autoOnairOnSharing && methodToCall === "DisableShareMode") setOnair(false);
        });
      }
    } catch (error) {
      console.log("disableShareSync - " + error);
    }
  };

  broadcastFile = (file: IGalleryFile) => {
   
    this.rootStore.playerStore.isZoomPortionEnabled= false;
   
    this.rootStore.commonStore.setGalleryFile(file);
    this.shareContentToAttendants();
    this.shareContentToScreens();
  }

  shareContentToAttendants = () => {
    this.rootStore.playerStore.setSharedObject();
    this.sendSharedSlide();
  }

  shareContentToScreens = () => {
   
    this.rootStore.playerStore.setSharedWidget();
     this.sendSharedWidget();
  }

 
  VideoWidgetCommandEvent = (command: VideoWidgetCommandTypes) => {
    const {setSharedWidget, changeCurrentWidgetVideoCommand} = this.rootStore.playerStore;
    setSharedWidget();
    changeCurrentWidgetVideoCommand(command);
    this.sendSharedWidget();
    changeCurrentWidgetVideoCommand("");
  }

  ImageWidgetZwibblerEvent = () => {
    this.rootStore.playerStore.setSharedWidget();
    this.sendSharedWidget();
  }

  ScreenQrWidgetEvent = (url: string, code: string, screenName: string) => {
    const {setCurrentSharedWidgetScreenQR} = this.rootStore.playerStore;
    setCurrentSharedWidgetScreenQR(url, code, screenName);
    this.rootStore.playerStore.isZoomPortionEnabled= false;
    this.sendSharedWidget();
  }

  sendSharedWidget = async () => {
    try {
      const {isOnair, activatedScreens, personalScreen} = this.rootStore.screensStore;
      const { sharedWidget, isZoomPortionEnabled } = this.rootStore.playerStore;
      if (!this.sharingWidgetInProgress) {
        this.sharingWidgetInProgress = true;
        if (isOnair && activatedScreens && sharedWidget) {
          //agent sharing screen API
          let connections = activatedScreens.map(x => x.id);
          if (personalScreen && personalScreen.status === screenStatusType.Activated)
            connections.push(personalScreen.id)
          // toast.info(`sharing data ${JSON.stringify(sharedWidget)} to following screen connections: ${connections}`);
          if(isZoomPortionEnabled){
            await agent.Screen.showWidgetZoomPortion(connections)
           } 
           else{
          await agent.Screen.shareWidget(sharedWidget, connections)
           }
        }
        runInAction(() => this.sharingWidgetInProgress = false);
      }
    } catch (error) {
      console.log(error);
      runInAction(() => this.sharingWidgetInProgress = false);
    }
  }

  sendSharedSlide = async () => {
    try {
      if (
        this.connection &&
        this.connection.state === signalR.HubConnectionState.Connected &&
        this.rootStore.playerStore.attendingMeeting &&
        this.rootStore.playerStore.isSharing &&
        this.rootStore.playerStore.sharedObject
      ) {
      let isSameObject :boolean = false;
     if(this.rootStore.playerStore.currentsharedObject?.data === this.rootStore.playerStore.sharedObject?.data){ 

      isSameObject = true;
      }
        this.connection!.invoke(
          "SendSharedObject",
          this.rootStore.playerStore.attendingMeeting.id,
          this.rootStore.playerStore.sharedObject,
          isSameObject
        )
          .then()
          .catch();

          this.rootStore.playerStore.currentsharedObject= this.rootStore.playerStore.sharedObject;
      }
    } catch (error) {
      console.log("sendSharedSlide - " + error);
    }
  };

  sendSharedZwibblerDrawing = async (drawingData: string) => {
    try {
      if (
        this.connection &&
        this.connection.state === signalR.HubConnectionState.Connected &&
        this.rootStore.playerStore.attendingMeeting &&
        this.rootStore.playerStore.isSharing
      ) {
        this.connection!.invoke(
          "SendSharedDrawing",
          this.rootStore.playerStore.attendingMeeting.id,
          drawingData
        )
          .then()
          .catch();
      }
    } catch (error) {
      console.log("sendSharedZwibblerDrawing - " + error);
    }
  };

  showSurveyToAttendees = async (surveyId: number) => {
    try {
      if (this.rootStore.playerStore.attendingMeeting) {
        this.connection!.invoke(
          "ShowSurveyToAttendees",
          this.rootStore.playerStore.attendingMeeting.id,
          surveyId
        ).then(() => {
          toast.success(getToastTranslation("survey_invitation_ok"))
        }).catch((error) => console.log("ShowSurveyToAttendees - " + error));
      }
    } catch (error) {
      console.log("ShowSurveyToAttendees - " + error);
    }
  };

  showSurveyResultsToAttendees = async (surveyId: number) => {
    try {
      if (this.rootStore.playerStore.attendingMeeting) {
        this.connection!.invoke(
          "ShowSurveyResultsToAttendees",
          this.rootStore.playerStore.attendingMeeting.id,
          surveyId
        ).then(() => {
          toast.success(getToastTranslation("sharing_results_ok"))
        }).catch((error) => console.log("showSurveyResultsToAttendees - " + error));
      }
    } catch (error) {
      console.log("showSurveyResultsToAttendees - " + error);
    }
  };

  sendPingMsg = async (group:string, text: string) => {
    try {
        this.connection!.invoke(
          "SendPingMsg",
          group,
          text
        )
          .then()
          .catch();
    } catch (error) {
      console.log("sendPingMsg - " + error);
    }
  };

  stopSignalR = () => {
    if (this.connection) {
      this.connection
        .stop()
        .then(() => console.log("close OK"))
        .catch(() => console.log("close KO"))
        .finally(() => runInAction(() => (this.connection = null)));
    }
  };

  cssTenantOffline = async (tenant: ITenant) => {
    //this.rootStore.commonStore.theme = cmsThemes.get("template")
    await this.rootStore.commonStore.loadOfflineThemeTenant(tenant);

    console.log("THEME OFFLINE:" + tenant.theme);
  }
}
